// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lfvj","textarea":"styles_textarea__7809z"};